import React from "react";
import Context from './Context'
import Offers from './Offers'
import Questions from './Questions'

export default class Tab2 extends React.Component {

  state = {
    options: [
      {value: 'Dep', label: "Dépannage"},
      {value: 'deplacement', label: "Déplacement"},
      {value: 'gardEnf', label: "Garde d'enfants"},
      {value: 'achatVehicule', label: "Coach Auto"},
      {value: 'demenagment', label: "Démenagement"},
      {value: 'hebergement', label: "Hébergement"},
      {value: 'mobilreduite', label: "Mobilté réduite"},
      {value: 'remp', label: "Véhicule de remplacement"},
      {value: 'loc', label: "Véhicule de location"},
      {value: 'gardAni', label: "Garde d'animaux"},
      {value: 'deplVoiture', label: "Déplacement de voiture"},
      {value: 'servicePersonne', label: "Service à domicile"},
    ],
    defaultValues: []
  };

  onChange = (e) => {
    console.log('.....value', e.target.value)
    this.setState({
      defaultValues: e.target.value === 'yes' ?
        [
          {value: 'deplacement', label: "Déplacement"},
          {value: 'Dep', label: "Dépannage"},
          {value: 'gardEnf', label: "Garde d'enfants"}
        ] : []
    })
  };

  render() {
    const styles = {
      title: {
        fontFamily: 'Poppins',
        fontWeight: 600,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: 10,
      },
    };

    return (
      <div className="tab2">
        <div className="offer-params">
          <div className="card context-info">
            <div style={{padding: 0}} className="card-content">
              <div style={styles.title} className="header-title">
                <span className="card-title" className="header-label">Informations supplémentaires</span>
              </div>
              <Context/>
            </div>
          </div>
          <div className="card questions">
            <div style={{padding: 0}} className="card-content">
              <div style={{...styles.title, backgroundColor: '#55CCCC'}} className="header-title">
                <span className="card-title" className="header-label">Questions</span>
              </div>
              <Questions onChange={this.onChange}/>
            </div>
          </div>
        </div>
        <div className="offers-content">
          <Offers options={this.state.options} defaultOptions={this.state.defaultValues}/>
        </div>
      </div>
    )
  }
}